export enum QueryAction {
	CREATE_USER = "CREATE_USER",
	UPDATE_USER = "UPDATE_USER",
	VERIFY_USER = "VERIFY_USER",
	CREATE_TRANSACTION_PAYMENT_REQUEST = "CREATE_TRANSACTION_PAYMENT_REQUEST",
	CREATE_TRANSACTION_PAYMENT_GATEWAY = "CREATE_TRANSACTION_PAYMENT_GATEWAY",
	CREATE_TRANSACTION_BANK_TRANSFER = "CREATE_TRANSACTION_BANK_TRANSFER",
	UPDATE_TRANSACTION_PAYMENT_REQUEST = "UPDATE_TRANSACTION_PAYMENT_REQUEST",
	UPDATE_TRANSACTION_BANK_TRANSFER = "UPDATE_TRANSACTION_BANK_TRANSFER",
	GET_FIRE_BANKS = "GET_FIRE_BANKS",
	GET = "GET",
	UPDATE_TRANSACTION = "UPDATE_TRANSACTION",
	UPDATE_BENEFICIARY = "UPDATE_BENEFICIARY",
	DELETE_BENEFICIARY = "DELETE_BENEFICIARY",
	CREATE_BENEFICIARY = "CREATE_BENEFICIARY",
	PASSWORD_RESET = "PASSWORD_RESET",
	COMPLETE_REG = "COMPLETE_REG",
	CREATE_WALLET = "CREATE_WALLET",
}
